import React from "react";

import ListItemText from "@material-ui/core/ListItemText";
import ListItem from "@material-ui/core/ListItem";
import withStyles from "@material-ui/core/styles/withStyles";
import Typography from "storybookComponents/Typography"
//import "./index.css";
import { Link } from "react-router-dom";
import ReactTimeAgo from 'react-time-ago'

const ListItems = ({
  classes: { setPointer, lineHeight, displayBlock, paddingright },
  key,
  title,
  subtitle,
  timecreated,
  to,
}) => {
  console.log(to, "tolink");
  return (
    <Link target="_blank" to={typeof to !== "undefined" ? to : "/#"}>
      <ListItem
        divider
        key={key} //props key here
        className={setPointer}
      >
        <ListItemText
          primary={
            <Typography
              type="body1"
              font_weight={600}
              className={(lineHeight, paddingright)}
              gutterBottom
            >
              {title}
            </Typography>
          }
          secondary={
            <>
              <Typography component="span" type="body1" className={lineHeight}>
                {subtitle}
              </Typography>
              <Typography
                component="span"
                className={displayBlock}
                type="body2"
                color="deepGrey"
                font_weight={300}
              >
                <ReactTimeAgo date={timecreated} locale="en-US" />
              </Typography>
            </>
          }
        // onClick={e => handleClick(e, { id, header, body, status, ...n })}
        />
      </ListItem>
    </Link>
  );
};

const styles = (theme) => ({
  paddingright: {
    paddingRight: 50,
  },
  setPointer: {
    cursor: "pointer",
  },
  lineHeight: {
    lineHeight: 1.2,
  },
  spacing: {
    marginBottom: theme.spacing_unit.xs,
  },
  displayBlock: {
    display: "block",
    marginTop: theme.spacing_unit.xs,
  },
});

export default React.memo(withStyles(styles)(ListItems));
